/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FormatNumber = {
    format: FormatNumber.format;
    decimals: number;
    thousandsSeparator?: boolean;
};
export namespace FormatNumber {
    export enum format {
        NUMBER = 'number',
    }
}

